export class Form {
  fields: { [key: string]: FormField } = {};
  invalid: { [key: string]: boolean } = {};

  clear() {
    this.invalid = {};
  }

  add(name: string, valueFn: () => any): FormField {
    const field = new FormField(name, valueFn);
    this.fields[name] = field;
    return field;
  }

  isValid() {
    let formValid = true;
    for (const name in this.fields) {
      const field = this.fields[name];
      let fieldInvalid = false;
      for (const validator of field.validators) {
        try {
          if (!validator()) {
            console.log(`Field ${name} is invalid with value ${field.valueFn()}`);
            fieldInvalid = true;
            break;
          }
        } catch (e) {
          fieldInvalid = true;
          break;
        }
      }
      this.invalid[name] = fieldInvalid;
      if (fieldInvalid) {
        formValid = false;
      }
    }
    return formValid;
  }
}

export class FormField {
  validators: (() => boolean)[] = [];

  constructor(private name: string,
              public valueFn: () => any) {

  }

  isNumber(): FormField {
    this.validators.push(() => {
      const value = this.valueFn();
      return typeof value === 'number';
    });
    return this;
  }

  isRequired(): FormField {
    this.validators.push(() => {
      const value = this.valueFn();
      return value !== null && value !== undefined;
    });
    return this;
  }

  isSmaller(otherValueFn: () => any): FormField {
    this.validators.push(() => {
      const value = this.valueFn();
      const otherValue = otherValueFn();
      return value < otherValue;
    });
    return this;
  }

  isGreater(otherValueFn: () => any): FormField {
    this.validators.push(() => {
      const value = this.valueFn();
      const otherValue = otherValueFn();
      return value > otherValue;
    });
    return this;
  }
}